"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textfieldConfig = exports.telephoneConfig = exports.numberConfig = exports.emailConfig = exports.currencyConfig = exports.TextfieldType = exports.TextfieldElementDefinition = exports.TextfieldDefinition = exports.TelephoneFieldDefinition = exports.NumberFieldDefinition = exports.EmailFieldDefinition = exports.CurrencyFieldDefinition = void 0;

var _types = require("../../types");

var _config = require("../config");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var FieldConfigDefinition = _flowRuntime["default"].tdz(function () {
  return _config.FieldConfigDefinition;
});

var FieldElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.FieldElementDefinition;
});

var FieldInfoDefinition = _flowRuntime["default"].tdz(function () {
  return _types.FieldInfoDefinition;
});

var TextfieldType = _flowRuntime["default"].type("TextfieldType", _flowRuntime["default"].union(_flowRuntime["default"].string("currency"), _flowRuntime["default"].string("email"), _flowRuntime["default"].string("number"), _flowRuntime["default"].string("text"), _flowRuntime["default"].string("textarea")));

exports.TextfieldType = TextfieldType;

var TextfieldElementDefinition = _flowRuntime["default"].type("TextfieldElementDefinition", _flowRuntime["default"].spread(_flowRuntime["default"].ref(FieldElementDefinition), _flowRuntime["default"].object(_flowRuntime["default"].property("autoComplete", _flowRuntime["default"].string(), true), _flowRuntime["default"].property("hideLabel", _flowRuntime["default"]["boolean"](), true), _flowRuntime["default"].property("info", _flowRuntime["default"].ref(FieldInfoDefinition), true), _flowRuntime["default"].property("inputMode", _flowRuntime["default"].string(), true), _flowRuntime["default"].property("min", _flowRuntime["default"].number(), true), _flowRuntime["default"].property("maxLength", _flowRuntime["default"].number(), true), _flowRuntime["default"].property("normalize", _flowRuntime["default"].string(), true), _flowRuntime["default"].property("pattern", _flowRuntime["default"].string(), true), _flowRuntime["default"].property("placeholder", _flowRuntime["default"].string(), true))));

exports.TextfieldElementDefinition = TextfieldElementDefinition;

var NumberFieldDefinition = _flowRuntime["default"].type("NumberFieldDefinition", _flowRuntime["default"].spread(TextfieldElementDefinition, _flowRuntime["default"].object(_flowRuntime["default"].property("type", _flowRuntime["default"].string("number")))));

exports.NumberFieldDefinition = NumberFieldDefinition;

var TelephoneFieldDefinition = _flowRuntime["default"].type("TelephoneFieldDefinition", _flowRuntime["default"].spread(TextfieldElementDefinition, _flowRuntime["default"].object(_flowRuntime["default"].property("type", _flowRuntime["default"].string("tel")))));

exports.TelephoneFieldDefinition = TelephoneFieldDefinition;

var CurrencyFieldDefinition = _flowRuntime["default"].type("CurrencyFieldDefinition", _flowRuntime["default"].spread(TextfieldElementDefinition, _flowRuntime["default"].object(_flowRuntime["default"].property("type", _flowRuntime["default"].string("currency")))));

exports.CurrencyFieldDefinition = CurrencyFieldDefinition;

var EmailFieldDefinition = _flowRuntime["default"].type("EmailFieldDefinition", _flowRuntime["default"].spread(TextfieldElementDefinition, _flowRuntime["default"].object(_flowRuntime["default"].property("type", _flowRuntime["default"].string("email")))));

exports.EmailFieldDefinition = EmailFieldDefinition;

var TextfieldDefinition = _flowRuntime["default"].type("TextfieldDefinition", _flowRuntime["default"].spread(TextfieldElementDefinition, _flowRuntime["default"].object(_flowRuntime["default"].property("type", _flowRuntime["default"].string("text")))));

exports.TextfieldDefinition = TextfieldDefinition;
var emailConfig = {
  type: 'email',
  validation: [{
    email: true
  }]
};
exports.emailConfig = emailConfig;
var currencyConfig = {
  type: 'currency'
};
exports.currencyConfig = currencyConfig;
var numberConfig = {
  type: 'number'
};
exports.numberConfig = numberConfig;
var telephoneConfig = {
  type: 'tel'
};
exports.telephoneConfig = telephoneConfig;
var textfieldConfig = {
  type: 'text'
};
exports.textfieldConfig = textfieldConfig;